import React, {
  useRef,
  useState,
  useMemo,
  useEffect,
} from 'react';
import _ from 'lodash';
import {
  Select,
  Input,
  Dialog,
  Loading,
} from '@tencent/spaui';
import { ListView } from '@tencent/ptp-fe-common';

import { RPCFactory } from '../../../utils/RequestUtil';
import { isXunda } from '../../../utils';
import { CorpSelector } from '../qw/corpSelector';

const QW_ROLE_MAP = {
  1: '企微管理员',
  2: '企微客服经理',
  3: '企微客服人员',
  4: '企微运营专员',
};

/**
 * 检查是否有某个操作的具体权限
 */
const valid = (str) => {
  const rights = _.get(window, 'pageProps.privileges');
  if (!rights) return true;
  return rights.indexOf(str) !== -1 || window.pageProps.originRole === 'OPERATOR_ROLE_LEADS_OBSERVER';
};

// 编辑的弹窗
const EditDialog = (props) => {
  if (props.currentDialogType !== 'options') return null;
  const data = props.dialogData;
  const [teams, setTeams] = useState((data.groups || []).map(item => item.groupId));
  const [teamList, setTeamList] = useState([]);
  const [role, setRole] = useState(data.role);

  const handleCloseDialog = () => {
    if (typeof props.onDialogCancel !== 'function') return;
    props.onDialogCancel();
  };

  const handleSubmit = () => {
    RPCFactory.qwEmployee.update({
      role,
      wxWorkUserId: data.wxWorkUserId,
      groupIdList: teams,
    }).done(() => {
      handleCloseDialog();
      if (typeof props.onDialogSubmit !== 'function') return;
      props.onDialogSubmit();
    }).fail((ret, msg) => window.alert(msg));
  };

  // 获取团队列表
  useEffect(() => {
    RPCFactory.qwEmployee.getTeamList({
      pageIndex: 1,
      pageSize: 999,
    }).done((data) => {
      const arr = data.entities.map((item) => ({
        value: item.groupId,
        label: item.groupName,
      }));
      setTeamList(arr);
    }).fail((ret, msg) => window.alert(msg));
  }, []);

  return (
    <Dialog
      show
      title="编辑员工"
      type="simple"
      style={{ width: 450 }}
      onSubmit={handleSubmit}
      onCancel={handleCloseDialog}
      onClose={handleCloseDialog}
    >
      <div>
        <br />
        <p>姓名: <ww-open-data type="userName" openid={data.wxWorkUserId} /></p>
        <br />
        <p style={{ marginBottom: 5 }}>所属团队</p>
        <div>
          <Select
            multiple
            placeholder="请选择团队"
            onChange={(_, value) => setTeams(value)}
            value={teams || []}
            data={teamList}
          />
        </div>
        <br />
        <p style={{ marginBottom: 5 }}>角色</p>
        <div>
          <Select
            placeholder="请选择角色"
            onChange={(_, value) => setRole(value)}
            value={role}
            data={Object.keys(QW_ROLE_MAP).map(key => {
              return { value: +key, label: QW_ROLE_MAP[key] };
            })}
          />
        </div>
      </div>
    </Dialog>
  );
};

// 绑定的弹窗
const BindDialog = (props) => {
  if (props.currentDialogType !== 'bind') return null;
  const data = props.dialogData;
  const defaultBindType = useMemo(() => {
    if (data.qq) return 'qq';
    return 'wxId';
  }, [data]);
  const [bindType, setBindType] = useState(defaultBindType);
  const [bindValue, setBindValue] = useState(data[defaultBindType] || '');

  const handleCloseDialog = () => {
    if (typeof props.onDialogCancel !== 'function') return;
    props.onDialogCancel();
  };

  const handleBindTypeChange = (e, value) => {
    setBindType(value);
    setBindValue(data[value] || '');
  };

  const handleSubmit = () => {
    const qqReg = /^[1-9]\d+/;
    const typeMap = {
      qq: 'QQ号',
      wxId: '微信号',
    };
    const type = typeMap[bindType];
    if (!bindValue) {
      return window.alert(`请填写${type}`);
    }
    if (bindType === 'qq' && !qqReg.test(bindValue)) {
      return window.alert('请填写正确的QQ号');
    }
    let bindAccount = bindValue;
    if (bindType === 'qq') {
      bindAccount = +bindValue;
    }
    RPCFactory.qwEmployee.bind({
      [bindType]: bindAccount,
      wxWorkUserId: data.wxWorkUserId,
    }).done(() => {
      handleCloseDialog();
      if (typeof props.onDialogSubmit !== 'function') return;
      props.onDialogSubmit();
    }).fail((ret, msg) => window.alert(msg));
  };

  return (
    <Dialog
      show
      title="绑定"
      type="simple"
      style={{ width: 450 }}
      onSubmit={handleSubmit}
      onCancel={handleCloseDialog}
      onClose={handleCloseDialog}
    >
      <div>
        <br />
        <p>姓名: <ww-open-data type="userName" openid={data.wxWorkUserId} /></p>
        <br />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Select
            onChange={handleBindTypeChange}
            style={{ width: 95 }}
            value={bindType}
            data={[
              { value: 'qq', label: 'QQ号' },
              { value: 'wxId', label: '微信号' },
            ]}
          />
          <Input
            placeholder={`请填写${bindType === 'qq' ? 'QQ' : '微信'}号`}
            onChange={(_, value) => setBindValue(value)}
            style={{ zIndex: 1 }}
            value={bindValue}
          />
        </div>
      </div>
    </Dialog>
  );
};

// 解绑的弹窗
const UnBindDialog = (props) => {
  if (props.currentDialogType !== 'unbind') return null;

  const data = props.dialogData;

  const handleCloseDialog = () => {
    if (typeof props.onDialogCancel !== 'function') return;
    props.onDialogCancel();
  };

  const handleSubmit = () => {
    RPCFactory.qwEmployee.unbind(data.wxWorkUserId)
      .done(() => {
        handleCloseDialog();
        if (typeof props.onDialogSubmit !== 'function') return;
        props.onDialogSubmit();
      })
      .fail((ret, msg) => window.alert(msg));
  };

  return (
    <Dialog
      show
      type="normal"
      iconType="tip"
      title="确认是否解除绑定？"
      style={{ width: 400, textAlign: 'center' }}
      footerStyle={{ textAlign: 'center' }}
      onSubmit={handleSubmit}
      onCancel={handleCloseDialog}
      onClose={handleCloseDialog}
    >
      <p>解除绑定后该员工无法登录线索管理平台</p>
    </Dialog>
  );
};

const List = (props) => {
  const lvRef = useRef();
  /**
   * 页面状态：
   *   loading: 正在请求是否有访问权限
   *   loaded:  有权限访问
   *   noauth:  没有权限访问
   */
  const [pageStatus, setPageStatus] = useState('loaded');
  const [dialog, setDialog] = useState(null);
  const [dialogData, setDialogData] = useState({});

  const getList = (params) => new Promise((res, rej) => {
    RPCFactory.qwEmployee.getList(params)
      .done((data) => {
        const list = (data.entities || []).map((item) => {
          const row = {
            ...item,
            _data: item,
            wxId: item.wxId || '',
            qq: item.qq || '',
            role: QW_ROLE_MAP[item.role],
            name: item.name,
            groups: (item.groups || []).map((g) => g.groupName).join(', '),
          }
          return row;
        });
        const listData = {
          list,
          page_info: { total_number: data.size || 0 },
        };
        res(listData);
      })
      .fail((ret, msg) => {
        rej(msg);
        window.alert(msg);
      });
  });

  const reloadList = () => {
    if (typeof lvRef.current.loadList !== 'function') return;
    lvRef.current.loadList();
  };

  // 展示的列
  const showColumns = [
    'name',
    'wxWorkUserId',
    'qq',
    'wxId',
    'role',
    valid('WX_WORK_VIEWGROUP') ? 'groups' : null,
    'options',
  ].filter(Boolean);

  const handleOpenDialog = (type, data) => {
    setDialog(type);
    setDialogData(data);
  };

  // ----------------------- 列渲染方法 -----------------------
  // 员工姓名
  const renderName = (type, name, value, data) => {
    const { _data } = data;
    const style = {
      maxWidth: 300,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    return <ww-open-data style={style} type="userName" openid={_data.wxWorkUserId} />;
  };
  // 所属团队
  const renderGroups = (type, name, value) => {
    const style = {
      maxWidth: 300,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    return (<div style={style}>{ value }</div>);
  };

  // 操作
  const renderOptions = (type, name, value, data) => {
    const { _data } = data;
    const destFromQw = window.pageProps.source === 'qw';
    const unbind = !(_data.userId);
    const handler = (type) => (e) => {
      e.preventDefault();
      handleOpenDialog(type, _data);
    };
    return (
      <div>
        {
          !isXunda('cxd') && !_data.isSystem && valid('WX_WORK_UPDATEUSER') && (
            <a href="#" onClick={handler('options')}>编辑</a>
          )
        }
        {
          !destFromQw && !unbind && (
            <a href="#" onClick={handler('unbind')}>解绑</a>
          )
        }
      </div>
    );
  };
  // --------------------------------------------------------

  // 列渲染方法 map
  // 注意：使用的时候需要注入 name: [key] 属性
  const columnMap = {
    name: { title: '姓名', render: renderName },
    wxWorkUserId: { title: '员工ID' },
    qq: { title: 'QQ号码' },
    wxId: { title: '微信号码' },
    role: { title: '角色' },
    groups: { title: '所属团队', maxWidth: 300, render: renderGroups },
    options: { title: '操作', render: renderOptions },
  };

  const handleCloseDialog = () => {
    setDialogData({});
    setDialog(null);
  };

  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        const obj = { ...params };
        delete obj.page_size;
        delete obj.page;
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },
    toolbarConfig: {
      left: (
        <div className="toolbar-left">
          <h4>企业员工</h4>
        </div>
      ),
    },
    filterConfig: null,
    batchConfig: {},
    tableConfig: {
      defaultPageSize: 10,
      select: null,
      columns: showColumns.map(key => {
        return { ...columnMap[key], name: key };
      }),
      optionalConfig: {
        type: 'optional',
        target: 'wxWorkUserId',
        multiple: true,
        canOptional: true,
      },
    },
  });

  if (pageStatus === 'loading') {
    return <main id="main" className="main">
      <CorpSelector {...props} onChange={reloadList} />
      <div className="card borderd" style={{ paddingLeft: 20, fontSize: 0 }}>
        <Loading display="inline-block" />
        <span style={{
          fontSize: 14,
          lineHeight: '20px',
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: 6,
        }}>
          加载中...
        </span>
      </div>
    </main>
  }

  if (pageStatus === 'noauth') {
    return <main id="main" className="main">
      <div className="card borderd" style={{ paddingLeft: 24 }}>
        <div className="blue-tips">
          请先确认您已在企业微信后台开启同步通讯录，并在线索管理平台-企微运营-系统设置-权限配置模块输入同步通讯录密钥
        </div>
        <div className="no-employee"></div>
      </div>
    </main>
  }

  return (
    <main id="main" className="main">
      <CorpSelector {...props} onChange={reloadList} />
      <div className="page-pool">
        <div className="card borderd" style={{ paddingTop: 0 }}>
          <div className="datalist">
            <ListView
              className="lv"
              ref={lvRef}
              options={lvOptions}
              // payloads={this.payloads} // 不知道干啥用的
              // customFunctions={this.customFunctions} // 一样不知道干啥的
            />
          </div>
        </div>
      </div>
      <EditDialog
        currentDialogType={dialog}
        dialogData={dialogData}
        onDialogCancel={handleCloseDialog}
        onDialogSubmit={reloadList}
      />
      <BindDialog
        currentDialogType={dialog}
        dialogData={dialogData}
        onDialogCancel={handleCloseDialog}
        onDialogSubmit={reloadList}
      />
      <UnBindDialog
        currentDialogType={dialog}
        dialogData={dialogData}
        onDialogCancel={handleCloseDialog}
        onDialogSubmit={reloadList}
      />
    </main>
  );
};

export default List;
